import { speakOutloudCommand } from './v5/speak_outloud';

export const listenAppCommands = [
  speakOutloudCommand
];






